if ($ === undefined) window.$ = require('jquery')

import "@api/Api"

import Vue from "vue"

if ($('#api').length) {
  new Vue({
    el: "#api",
    components: {
    },
    activated() {
      console.warn('API Vue Activated...')
    }
  })
}
